define(function(require) {
	const radio = require('backbone.radio');
	const tpl = require('civicsViews/filter_view/t_itv_filter.hbs');
	const CodeDefinitionCollection = require('civicsCollections/code_definition_collection');
	const ViewManager = require('civicsUtils/view_manager');
	const AddressFilter = require('civicsViews/filter_view/address_filter');
	const JSV = require('civicsUtils/JSV');
	const AvailableFeatures = require('civicsUtils/available_features');
	const Utils = require('civicsUtils/general_utilities');
	const extendedFilterUtility = require('civicsUtils/extended_filter_utility');
	const SavedSearches = require('civicsViews/filter_view/saved_searches_view/v_lov_saved_searches.js')
	const ModalRegion = require('civicsUtils/modal_region');

	const dashboardChannel = radio.channel('dashboardChannel');
	const share_email_view = require('civicsViews/share_email_view/v_lov_share_url_modal');

	const saved_searches_collection = require('civicsCollections/portal/saved_searches_collection');


	var that;

	return Marionette.LayoutView.extend({
		template: tpl,
		tagName: 'div',
		className: '',
		regions: {
			modalRegion: {
				regionClass: ModalRegion,
				selector: 'body .rhythm-modals'
			},
			savedSearchesRegion: '.save-searches-region'
		},
		events: {
			'click @ui.btnSubmit': 'applyFilter',
			'click @ui.btnClear': 'clearFilter',
			'click @ui.btnClearSection': 'clearFilterSection',
			'click @ui.btnShare': 'shareClicked',
			'keyup @ui.checkboxInputFilter': 'onCheckboxFilterChange',
			'keyup @ui.filterForm': 'formSubmit',
			'change @ui.filterCheckboxes': 'instrumentSubTypeCheckboxChange',
			'droppyChange @ui.dateCriteriaPicker': 'dateCriteriaChanged'
		},
		ui:{
			filterForm: '.filter-form input',
			filterContentMainList:'.filter-content-main-list',
			filterContainer: '.filter-bar',
			filterCheckboxes: '.js-filterCheckboxes',
			btnSubmit:'.js-filterSubmit',
			btnClear:'.js-filterClear',
			btnClearSection: '.js-ClearSection',
			totalCount:'.total-filter-count',
			totalCountLabel: '.total-filter-count-container .scr',
			toggleButton: '.collapse-trigger',
			sectionCounts:'.filter-section-title .quantity-badge',
			checkboxInputFilter: '.checkboxInputFilter .input-search',
			dateCriteriaPicker: '.date-criteria-picker',
			btnShare: '.js-filterShare'
		},
		childEvents: {
			'child:rememberCriteria:filter': 'updateHashFromModelParameter'
		},
		initialize: function(options) {
			that = this;
			that.hashFilteredUpdate = false;
			if (options) {
				this.config = options;
				//the filter sends the selected filters to whatever view is listening using Radio
				if (this.config.radioChannel) {
					this.channel = radio.channel(this.config.radioChannel);
				} else if (__DEV__) {
					console.log('Please set up the radio channel object for the Filter view');
				}
			} else {
				if (__DEV__) {
					console.log('Options is not being passed properly to the filter view.')
				}
			}
			this.criteria = "";
			this.page = 1;
			this.sortField = "";
			this.statusFetch = $.Deferred();
			this.translationPath = options.translationPath;
			this.config.saveDashboardFiltersEnabled = this.config.saveDashboardFiltersEnabled && AvailableFeatures.AdditionalDashboardFilters();
			// this.modalRegion = options.modalRegion;
			that.needsAddress = false;
			this.filterName = options.filterName ? options.filterName : '';
			_.each(that.config.filterGroups, function(group) {
				group.id = that.config.filterGroups.indexOf(group);
				group.groupHeaderId = (group.groupHeader ? group.groupHeader : "groupHeader_" + group.id)  + "_" + that.config.filterName;
				_.each(group.controls, function(control) {
					if ( control.type.toUpperCase() == "ADDRESSES" ){
						that.needsAddress = true;
						that.addressFields = that.buildAddressFields(control);
						that.addressPrefix = _.isEmpty(control.propertyName) ? '' : control.propertyName;
					}
				});
			});

			if(that.needsAddress) {
				that.buildAddressDropDownFields();
			}	else {
				this.statusFetch.resolve();
			}

			this.listenTo(dashboardChannel, 'updateHashURL', (url) => {
				that.onUpdateHashUrl(url);
				this.onFetchSavedSearches();
			});

			// HPS-141742: use an arrow function so `this` is the specific filter view instance. The
			// module-level `that` is reassigned by every filter view's initialize(), so on pages with
			// multiple filter views (e.g. the My Dashboard tabs) all of these hashchange handlers ended
			// up pointing at whichever view initialized last. That made one view's paging hash-change
			// slip past another view's guard (`hashFilteredUpdate`, which is set per-instance), firing a
			// spurious applyFilter() that re-fetched page 1 and raced/overwrote the paged results ->
			// "pagination needs a double click".
			$(window).on("hashchange", () => {
				// Get URL hash parameters
				var urlParams = App.params.get() || {};

				// Check if hash was changed by a button or not
				//urlParams[this.config.filterType] will only be populated if the urlParameter contains a hash for this portlet
				//for example, urlParams['projects'] or urlParams['assignments']. The window.on('hashchange') can be initiated by any of these portlets,
				//and all of them will react to it.this prevents them from all updating when one portlet is filtered.
				if (this.hashFilteredUpdate == false &&
					this.config.filterType != null &&
					urlParams[this.config.filterType] != null) {
					this.config.filterURL = urlParams.filter;

					this.updateFormUsingHash();
					this.applyFilter();
				}

				this.hashFilteredUpdate = false;
			});
		},
		onRender: function() {
			// to prevent on rerendering and reapply again the default filter after the statusFetch promise
			$.when(this.statusFetch).done(()=> {
				this.onFetchSavedSearches();
			});
		},
		onShow: function() {
			// if (__DEV__) console.log('itv_filter -- onShow top');
			// if ( this.config.filterGroups ){
			// 	_.forEach(this.config.filterGroups, function(group){
			// 		var oGroup = self.newFilterGroup(group);
			// 		if (oGroup ){
			// 			self.ui.filterContentMainList.append(oGroup);
			// 		}
			// 	});
			// }

			// since we have added new control on the fly, we have to run theme Init here to initialize the specialized controls.
			// IMPORTANT - do not run theme init more than once in the same view as it will register those click event more than once
			// if (__DEV__) console.log('itv_filter -- onShow just before rhythmThemeInit');
			$.when(this.statusFetch).done(()=> {
				if(this.needsAddress) {
					this.render();
				}
				this.$el.rhythmThemeInit();
				this.$el.rhythmThemeInitCivics();

				// A11y: Give each datepicker dialog a unique aria-label.
				// Reads the field name from the associated label element in the DOM.
				this.$el.on('click', '[id^="DatePickerButton_"]', function() {
					var $btn = $(this);
					var fieldName = $btn.closest('.field').find('label, .input-label').first().text().trim();
					setTimeout(function() {
						var $widget = $btn.closest('.input-group').find('.bootstrap-datetimepicker-widget');
						if ($widget.length && fieldName) {
							$widget.attr('aria-label', i18n.t('CIVICS.COMMON.CHOOSE_DATE_FOR', { name: fieldName }));
						}
					}, 100);
				});

				// hack ... until we have our new control..clear all values
				//self.clearSpecific(undefined,!this.config.skipInitialApplyFilter);


				// Setting all the attributes
				this.updateFormUsingHash();
				// filter already execute from cardview list.
				if (this.config.usingSavedQueryForInitialLoadPromise != null) {
					this.config.usingSavedQueryForInitialLoadPromise.resolve(true);
				}
				this.fillQuantityFacets();
					// passing the skipInitialApplyFilter so applyFilter can be called no matter what.
					// this needs to be called to calculate the counts.
				// self.applyFilter(null,self.config.skipInitialApplyFilter, self.config.isInitialLoad );
			});
		},
		onFetchSavedSearches: function () {
			if (!AvailableFeatures.AdditionalDashboardFilters() || !this.config.saveDashboardFiltersEnabled) {
				this.config.defaultSearchCheckPromise?.resolve();
				return;
			}

			const source = this.config.filterType === 'tasks'
							? 'inspections'
							: this.config.filterName?.toLowerCase() === 'mytaskcard'
								? 'inspections'
								: 'projects';

			this._savedSearchesCache = this._savedSearchesCache || {}; // cache saved searches
			if (this._savedSearchesCache[source]) {
				// Use cached collection
				this.getRegion('savedSearchesRegion').show(new SavedSearches({
					config: this.config,
					collection: this._savedSearchesCache[source]
				}));
				return; 
			}

			// Fetch and cache
			const collection = new saved_searches_collection();
			collection.fetch({
				data: { source },
				success: () => {
					this._savedSearchesCache[source] = collection;

					this.getRegion('savedSearchesRegion').show(new SavedSearches({
						config: this.config,
						collection: collection
					}));
				},
				error: (collection, response) => {
					ViewManager.errorToWindow(response, this);
					// HPS-142176: fetch failed, so unblock the gated initial fetch in card_view_list.
					this.config.defaultSearchCheckPromise?.resolve();
				}
			});
		},
		onReceiveCriteriaValue: function(value) {
			this.criteria = value;
		},
		onReceivePageValue: function(value) {
			this.page = parseInt(value) ? parseInt(value) : 1;
		},
		onReceiveSortValue: function(value) {
			this.sortField = value;
		},
		onUpdateHashUrl: function(url) {
			// create event that will alert the portlet code that the filter is doing the URL update
			this.hashFilteredUpdate = true;

			if(url != window.location.hash) {
				window.location.hash = url;
			}
		},
		onUpdateHashForm: function() {
			this.updateHashFromModelParameter();
		},
		updateFormUsingHash: function() {
			// get the URL string from the portlet and convert it to form element paramaters
			var filterUrl = this.config.filterURL;
			var splithash = window.location.hash.split('/');
			var hashPage = undefined;
			var hasPage = false;
			var hasFormBeenSet = false;

			// populate filter options from page load (filterUrl already filled)
			if(filterUrl !== undefined) {
				hashPage = splithash[0];
			}

			// populate filter options from url
			if(filterUrl === undefined) {
				const matched = this.matchFilterUrlHashes(splithash);
				if (matched) {
					filterUrl = matched.filterUrl;
					hashPage = matched.hashPage;
				}
			}

			// populate filter options from session
			if(filterUrl === undefined && this.config.useSessionStorage == true) {
				var sessionFilterWhole = App.sessionStorage.get('CIVICS', `FILTER_${this.config.filterType.toUpperCase()}_DATA`); // Use backticks for better readability and cleaner syntax
				if(sessionFilterWhole !== undefined) {
					var sessionFilter = sessionFilterWhole.split('/');
					const matched = this.matchFilterUrlHashes(sessionFilter);
					if (matched) {
						filterUrl = matched.filterUrl;
						hashPage = matched.hashPage;
					}
				}
			}

			// execute if the filterUrl is not empty because it cause of clearing the default filters
			if ((hashPage !== undefined && hashPage.indexOf(this.config.filterType) >= 0 && !_.isEmpty(filterUrl))) {
				// how to properly clear form before query string drops in
				this.clearSpecific(null, false);

				hasFormBeenSet = true;
				let URLParamsObj = undefined;
				try{
					// Parse WITHOUT stripping '%'. The '%' wildcards only need removing from "Like"
					// search text fields (applyFilter wraps those as %value%); stripping '%' from the
					// whole object also wiped legitimate '%' out of exact-match codes (e.g. an
					// instrument type code containing '%'), so those checkboxes never matched and
					// weren't checked when loaded from the URL. Strip '%' only from Like values. HPS-137769
					URLParamsObj =  JSON.parse(extendedFilterUtility.unMinifyFilterString(filterUrl));
					this.stripLikeWildcards(URLParamsObj && URLParamsObj.extendedFilter);
				}catch(err){}
				// clean code for toWindow function
				var filtersToUpdate = this.buildFormValueWithQueryString(URLParamsObj);

				this.updatesFilters(filtersToUpdate);
				ViewManager.toWindow(this, filtersToUpdate); // Push the data into the fields

				$(".filters-group").each((i, e) => {
					this.countQuantity({filterGroup: e});
				});

				// Added to clear issues with filling date ranges through code
				// affecting the validation for the ranges
				$(".date-criteria-picker .droppy-input").each((i, e) => {
					let result = Utils.civicsDropdownValue($(e));
					if(result && result.length > 0) {
						this.updateStatusDates(e, result);
					}
				});
			}

			// If a page has not been assigned by the URL, set the filter to the first page
			if(!hasPage){
				this.triggerMethod('page:setPreload', 1);
			}

			return hasFormBeenSet;
		},
		matchFilterUrlHashes: function (hashes) {
			for (let i = 0; i < hashes.length; i++) {
				const hash = hashes[i];
				if (this.isValidFilterPage(hash)) {
					return { filterUrl: hashes[i + 1], hashPage: hashes[0] };
				}
			}
			return null;
		},
		isValidFilterPage: function (hash) {
			const validate = hash.toLowerCase();
			return (
				validate.indexOf("assignments") >= 0 ||
				validate.indexOf("projects") >= 0 ||
				validate.indexOf("task") >= 0 ||
				validate.indexOf("instrumentslist") >= 0
			);
		},
		updatesFilters: function (filters) {
			filters.forEach((filter) => {
				switch (filter.name) {
				case "statusDateCriteria.picker1.type":
					this.updateStatusDates($(`#${this.filterName}status-dropdown-1`).closest(".field"), filter.value);
					break;
				case "statusDateCriteria.picker2.type":
					this.updateStatusDates($(`#${this.filterName}status-dropdown-2`).closest(".field"), filter.value);
					break;
				case "statusDateCriteria.picker3.type":
					this.updateStatusDates($(`#${this.filterName}status-dropdown-3`).closest(".field"), filter.value);
					break;
				case "viewCriteria":
					this.triggerMethod('criteria:setValue', filter.value);
					break;
				case "sortOrder":
					this.triggerMethod('sort:setValue', filter.value);
					break;
				case "pageNumber":
					this.triggerMethod('page:setPreload', filter.value);
					hasPage = true;
					break;
				}
			});
		},
		instrumentSubTypeCheckboxChange: function(e) { //This function is to change the badge count when the checkbox changes.
			var src = $(e.target);
			this.countQuantity({filterGroup:src.closest(".filters-group")});
		},
		dateCriteriaChanged: function(e) {
			var drop = e.currentTarget;
			var result = e.result.data;
			this.updateStatusDates(drop, result);
		},
		updateStatusDates: function(drop, result){
			var from = $(drop).closest('.status-date-group').find('.date-from').find('.civics-datepicker');
			var to = $(drop).closest('.status-date-group').find('.date-to').find('.civics-datepicker');
			var fromLabel = $(drop).closest('.status-date-group').find('.date-from').find('label');
			var toLabel = $(drop).closest('.status-date-group').find('.date-to').find('label');

			var propertyFrom = '';
			var propertyTo = '';
			var idFrom = '';
			var idTo = '';

			if(result){
				propertyFrom = this.camelize(result) + "-from";
				propertyTo = this.camelize(result) + "-to";
				idFrom = propertyFrom + this.endCustom();
				idTo = propertyTo + this.endCustom();
			}

			//$(from).attr('id',idFrom);

			//$(to).attr('id',idTo);


			if(propertyFrom !=null) {
				$(from).attr('name',propertyFrom);
				$(from).attr('data-property',propertyFrom);
			} else {
				$(from).removeAttr('name');
			}

			if(idFrom !=null) {
				$(fromLabel).attr('for',idFrom);
			} else {
				$(fromLabel).removeAttr('for');
			}

			if(propertyTo !=null) {
				$(to).attr('data-property',propertyTo);
				$(to).attr('name',propertyTo);
			} else {
				$(to).removeAttr('name');
			}

			if(idTo !=null) {
				$(toLabel).attr('for',idTo);

			} else {
				$(toLabel).removeAttr('for');
			}

		},
		onCheckboxFilterChange:function(e) {
			var val = e.target.value.toLowerCase();
			var src = $(e.target);
			var group = src.closest(".input-group");
			var property = src.attr('data-property');

			this.onCheckboxFilter(val, src, this, property, group);
		},
		onCheckboxFilter:function(val, src, self, property, group) {
			//This function is to change the list of checkboxes and badge count
			var count = 0;

			//select inputs that are checkboxes and have the appropriate data-property set
			group.find("input[type='checkbox'][data-property='"+ property +"']").each(function() {
				if($(this).attr('data-displayName')!=undefined) {
					if($( this ).attr('data-displayName').toLowerCase().indexOf(val)<0){
						//fade out the checkbox
						$( this ).parent().parent().fadeOut(500);
					} else {
						$( this ).parent().parent().fadeIn(500);
						count++;
					}
				}
			});

			if(count > 10){
				if(!group.hasClass('more-than-ten')){
					group.find('.filter-checkboxes').addClass('more-than-ten');
				}
			} else {
				group.find('.filter-checkboxes').removeClass('more-than-ten');
			}

			self.countQuantity({filterGroup: src.closest(".filters-group")});
		},
		countQuantity: function(el){
			var self = this;
			var $filterGroup;
			if(el.filterGroup){
				$filterGroup = $(el.filterGroup);
			} else {
				$filterGroup = $(this).closest('.filters-group');
			}
			var $badge = $filterGroup.find('.quantity-badge');
			var $clear = $filterGroup.find('.js.ClearSection');
			var $checkboxes = $filterGroup.find('input[type=checkbox]');
			var groupHeader = $filterGroup.find('.filter-group-header').text();
			var count = 0;
			$checkboxes.each(function(){
				if($(this).is(':checked')){
					count++;
				}
			});

			if(count > 0) {
				$badge.show();
				$clear.show();
				if(count==1){
					$badge.parent().find('.scr').text(groupHeader+' '+i18n.t( 'CIVICS.COMMON.FILTER_APPLIED'));
				}
				else{
					$badge.parent().find('.scr').text(groupHeader+' '+i18n.t('CIVICS.COMMON.FILTERS_APPLIED'));
				}
			} else {
				$clear.hide();
			}

			$badge.text(count);
		},
		formSubmit: function(e) {
			if (e.which == 13) {
				// As ASCII code for ENTER key is "13"
				if(!$('.boostrap-datetimepicker-widget').find($(e.target)))
				this.applyFilter();
			}
		},
		fillQuantityFacets: function() {
			var filterCount = 0;

			this.ui.filterContentMainList.find('.input-group').each(function() {
				var $group = $(this);
				$group.find('input, select').each(function() {
					$input = $(this);

					// retrieve the special type first and make sure it is not a 'search' type before generating the filter
					var iSpecialType = $input.attr('data-specialType');

					// in order for any input to be picked up, a data-inputType has to be set ( making sure it is not the input added by the RhythmTheme )
					if ( $input.attr('data-inputType') && $input.attr('data-inputType').length > 0 && iSpecialType!='search') {
						//if this is a check box, and it's checked OR not a check box, and with a value that isn't default
						if($input.is(':checked') || ($input.attr('data-inputType')!='checkbox' && $input.val() && $input.val()!='default')) {
							filterCount++;
						}
					}
				});
			});

			// Use the total count to fill in the facet at the top of the filter
			this.totalCount(filterCount);
			if(filterCount > 0) {
				// I don't think we are going to hide the total count even when 0
				// this.ui.totalCount.show();
				this.ui.btnClear.show();

				if(filterCount==1) {
					this.ui.totalCountLabel.text(i18n.t('CIVICS.COMMON.FILTER_APPLIED'));
				} else {
					this.ui.totalCountLabel.text(i18n.t('CIVICS.COMMON.FILTERS_APPLIED'));
				}
			}

			// Fill out the rest of the filter facets if applicaable
			this.ui.filterContentMainList.find(".filters-group").each((i, e) => {
				this.countQuantity({filterGroup: e});
			});
		},
		applyFilter: function(e, disableNotifyParent, isInitialLoad) {
			var self = this;
			if(e){
				e.preventDefault();
			}
			var retFilter = {};
			var andFilter = [];
			var orFilter = [];
			var rawData = {};
			var queryStrings = []; // queryString = {id:xxx,value:xxx}
			var filterCount = 0;
			var statusDateDropErrors = [];

			this.ui.filterContentMainList.find('.input-group').each(function(){
				var $group = $(this);
				var gProperty = $group.attr('data-property');
				var gLogic = $group.attr('data-logic');
				var gExcludeFromFilter = ($group.attr('data-excludeFromFilter') == 'true') ? true : false;
				var gFilterGroupType = $group.attr('data-filterGroupType');
				var gGroupHeader = $group.attr('data-groupHeader');
				var groupFilter = [];
				var rawGroupFilter = [];
				$group.find('input, select').each(function(){
					$input = $(this);

					// retrieve the special type first and make sure it is not a 'search' type before
					// generating the filter
					var iSpecialType = $input.attr('data-specialType');

					// in order for any input to be picked up, a data-inputType has to be set ( making sure it is not the input added by the RhythmTheme )
					if ( $input.attr('data-inputType') && $input.attr('data-inputType').length > 0
								&& iSpecialType!='search'){
						//console.log('prop: '+$input.attr('data-property')+' disp: '+$input.attr('data-displayName')+' val: '+$input.val()+' '+$input.is(':checked'));
						//if this is a check box, and it's checked OR not a check box, and with a value that isn't default
						if($input.is(':checked') || ($input.attr('data-inputType')!='checkbox' && $input.val() && $input.val()!='default')){
							filterCount++;
							var iProperty = $input.attr('data-property');
							var iExcludeFromFilter = ($input.attr('data-excludeFromFilter') === 'true')? true:false;
							var iExcludeFromRawData = ($input.attr('data-excludeFromRawData') === 'true') ? true:false;
							var iQueryStringId = $input.attr('data-queryStringId');
							var iQueryStringPureBind = ($input.attr('data-queryStringPureBind') === 'true')? true:false;
							var iExtendedAttributes = $input.attr('data-extendedAttributes') == 'null' ? '' : $input.attr('data-extendedAttributes');
							var extendedAttributes = JSV.parse(iExtendedAttributes); // each name value pairs will be appended to the filter
							var iFilterType = $input.attr('data-filterType');
							var iInputType = $input.attr('data-inputType');
							var iDisplayName = $input.attr('data-displayName');
							var iAlternateValues = $input.attr('data-alternateValues');
							var iRelatedValues = $input.attr('data-relatedValues');
							var iValue = $input.val();
							var iSearchAlternateName = $input.attr('data-searchAlternateName');

							var autoIncrementForRange = false;
							// if input type is date, change the value to the ISO8601
							if ( iInputType.toLowerCase()=='date'){
								if ( iProperty == null || iProperty === '') {
									var drop = $input.closest('.status-date-group').find('.date-criteria-picker');
									var dropInput = drop.find('input');
									if(!statusDateDropErrors.includes(dropInput.attr('name'))) {
										statusDateDropErrors.push(dropInput.attr('name'));
									}
								}

								var oDate = new Date(Utils.createMoment(iValue));
								if( iFilterType==='range' && iProperty && iProperty.indexOf('-to')>0 ){
									// add a day to the filter if date only range is used
									oDate.setDate(oDate.getDate() + 1);
									autoIncrementForRange = true;
								}
								iValue = Utils.dateTimeStringFromDate(oDate); //isoFixed
							} else if (iInputType.toLowerCase() == 'select'){//account for getting the droppy value
								iValue = Utils.civicsDropdownValue($input);
							}

							//trim white space
							if ( iValue ){
								iValue = iValue.trim();
							}

							var props = {};

							if( iFilterType==='range' && iProperty && iProperty.indexOf('-from')>0 ){
								props.operator = 'GreaterThanOrEqual';
								gProperty = iProperty.replace('-from','');
							}
							else if( iFilterType==='range' && iProperty && iProperty.indexOf('-to')>0 ){
								if ( autoIncrementForRange ){
									props.operator = 'LessThan';
								}
								else{
									props.operator = 'LessThanOrEqual';
								}
								gProperty = iProperty.replace('-to','');
							}
							else if (iFilterType==='exact' || $input.is(':checked') ){
								props.operator = 'Equal';
							}
							else if( iFilterType==='address' ){
								props.operator = 'Like';
								iValue = '%'+iValue+'%';
							}
							else if( iFilterType==='end' ){		//only add the wildcard at the end
								props.operator = 'Like';
								iValue = iValue+'%';
							}
							else {
								props.operator = 'Like';
								iValue = '%'+iValue+'%';
							}

							props.property = (iFilterType==='range' || iFilterType === 'checkbox') ? gProperty : iProperty;

							if(iSearchAlternateName) {
								props.property = iValue;
							}

							props.value = iValue;


							// now extend the extendedAttributes
							_.forEach(extendedAttributes, pair=>{
								 props = _.extend(props,pair);
							});

							if (gProperty && gProperty.toLowerCase() == 'instrumentsubtype' && !_.isEmpty(props.instrumentType)) {
								if(AvailableFeatures.SubtypeFilterParam()){
									//instead of 2 objects inside the criteria removed the 2nd object that contains the instrument type
									//object that contains the instument type details will now be replaced the 'instrumentTypeID' which can now be retrieved from RS
									props = {
										property: 'instrumentsubtype',
										instrumentTypeID: props.instrumentTypeId,
										value: props.value
									}
								}
								else{
								var propsArr = [];
								propsArr.push(props);
								propsArr.push({
									operator:'Equal',
									property:'instrumentType',
									value:props.instrumentType
								});
								props = {
									operator: 'And',
									property:'instrumentSubType',
									criteria: propsArr
								};
							}
							}

							// Other Sub type Codes with the same description as the one displayed will be put to relatedValues
							if (gProperty && gProperty.toLowerCase() == 'instrumentsubtypecode') {
								if (iRelatedValues) {
									var relatedValues = iRelatedValues.split('|');
									if (relatedValues.length > 0) {
										var propsArr = [props]; // push first prop

										_.each(relatedValues, function(relatedValue) {
											propsArr.push({
												operator: props.operator,
												property: props.property,
												value: relatedValue
											});
										})

										// Value and Related Values will be wrapped in an OR group
										props = {
											operator: 'Or',
											property: props.property,
											criteria: propsArr
										};
									}
								}
							}

							if(!iExcludeFromRawData){
								rawGroupFilter.push(props);
							}

							// if this is also added to the query string and the query string id is provided
							if ( iQueryStringId ){
								var queryStringProps = {};
								if ( iQueryStringPureBind ){
									queryStringProps = _.extend({},props);
									//user pure bind for query strings... eg.. if prop id = addr.zipcode, it becomes zipcode
									queryStringProps.property = queryStringProps.property.substring(queryStringProps.property.lastIndexOf(".")+1);
								}
								else{
									queryStringProps = props;
								}
								queryStrings.push ({
									id : iQueryStringId,
									value: queryStringProps
								});
							}

							//console.log(!iExcludeFromFilter +' '+ !gExcludeFromFilter)
							if(!iExcludeFromFilter && !gExcludeFromFilter){
								if( props.property != null && props.property != '')
									groupFilter.push(props);
								//push the alternate values onto the group filter
								if(iAlternateValues){
									var alts = iAlternateValues.split('|');
									for (var i = 0; i < alts.length; i++) {
										var props2 = $.extend(true,{},props);
										props2.value = alts[i];
										groupFilter.push(props2);
									};
								}
							}

							that.buildFilterTag({
								gProperty:gProperty,
								gLogic:gLogic,
								gExcludeFromFilter:gExcludeFromFilter,
								gFilterGroupType:gFilterGroupType,
								gGroupHeader:gGroupHeader,
								iProperty:iProperty,
								iExcludeFromFilter:iExcludeFromFilter,
								iExcludeFromRawData:iExcludeFromRawData,
								iFilterType:iFilterType,
								iInputType:iInputType,
								iDisplayName:iDisplayName,
								iSpecialType:iSpecialType,
								iAlternateValues:iAlternateValues,
								iValue:iValue,
								id:$input.attr('id')
							});
						}
					}
				});
				if( rawData[gProperty] )
					rawData[gProperty] = rawData[gProperty].concat(rawGroupFilter);			//We need to combine in cases of date ranges that are treated separately
				else
					rawData[gProperty] = rawGroupFilter;

				//to make things a bit easier when reading/parsing, we will
				//combine all of our 'And' groups into one array while preserving the
				//integrity of our 'Or' groups by pushing them seperately into another array.
				if(groupFilter.length==1){
					//if there's only one checkbox checked, we don't need to worry about using an or
					andFilter.push(groupFilter[0]);
				} else if(groupFilter.length>1){
					if(gLogic === 'Or'){
						orFilter.push({
							Or:groupFilter
						});
					} else {
						//see http://stackoverflow.com/a/4156156/198584 for details on push.apply
						andFilter.push.apply(andFilter,groupFilter);
					}
				}
				//console.log(gProperty+' groupFilter',groupFilter);
			});

			// add the datecriteria on rawData so that we can add it on URL parameter
			rawData['dateCriteriaPicker'] = [];
			this.ui.filterContentMainList.find('.date-criteria-picker').each(function(){
				datepicker = $(this);
				datepicker.find('input, select').each(function(){
					$input = $(this);
					var iName = $input.attr('name');
					var iValue = Utils.civicsDropdownValue($input);
					if(iValue)
						rawData['dateCriteriaPicker'].push({property: iName, value: iValue});
				});
			});

			ViewManager.resetErrorMessages(this);

			var props = [];

			this.ui.filterContentMainList.find('.datepicker-range-container').each(function(){
				var from, to;
				var fromInput, toInput;
				$(this).find('input').each(function(){
					var i = $(this);
					var prop = i.attr('data-property');

					if(prop) {
						if(prop.indexOf("-from") > 0) {
							from = i.val();
							fromInput = i;
						}

						if(prop.indexOf("-to") > 0){
							to = i.val();
							toInput = i;
						}
					}
				});

				if(!_.isEmpty(from) && !_.isEmpty(to)){
					if(Utils.dateTimeString(to) < Utils.dateTimeString(from)) {
						props.push(fromInput.attr('data-property'));
						props.push(toInput.attr('data-property'));
					}
				} else if (_.isEmpty(from) && _.isEmpty(to)) {
					fromInput = $(this).find('input[type="text"]').get(0);
					from = $(fromInput).val();
					toInput = $(this).find('input[type="text"]').get(1);
					to = $(toInput).val();

					if(Utils.dateTimeString(to) < Utils.dateTimeString(from)) {
						$(fromInput).parents(".field").append( $('<div class="helper-msg-container"><div class="error-message">' + Utils.outputErrorMessage(i18n.t('CIVICS.COMMON.STATUS_DATE_ORDER')) + '</div></div>'));
						$(toInput).parents(".field").append( $('<div class="helper-msg-container"><div class="error-message">' + Utils.outputErrorMessage(i18n.t('CIVICS.COMMON.STATUS_DATE_ORDER')) + '</div></div>'));
						$(fromInput).parents(".field").addClass("error");
						$(toInput).parents(".field").addClass("error");
					}
				}
			});

			var hasError = false;
			var validationErrors = {};
			var hasStatusDateOrderErrors = false;
			if(props.length > 0) {
				hasError = true;
				hasStatusDateOrderErrors = true;

				props.forEach(function(element) {
					var inputs = self.ui.filterContentMainList.find('.datepicker-range-container');
					inputs.each(function() {
						var inputFrom = $(this).find('[data-property*="from"]');
						var inputTo = $(this).find('[data-property*="to"]');

						if(!_.isEmpty(inputFrom.val()) && !_.isEmpty(inputTo.val())) {
							var inp = $(this).find('[name="'+element+'"]');
							inp.parents(".field").append( $('<div class="helper-msg-container"><div class="error-message">' + Utils.outputErrorMessage(i18n.t('CIVICS.COMMON.STATUS_DATE_ORDER')) + '</div></div>'));
							inp.parents(".field").addClass("error");
						}
					});
				});
			}

			if(statusDateDropErrors.length > 0){
				hasError = true;

				statusDateDropErrors.forEach(function(element) {
					validationErrors[element] = i18n.t('CIVICS.COMMON.STATUS_DATE_REQUIRED');
				});

			}

			var statusDropdowns = self.$el.find('.date-criteria-picker .droppy-input');
			var hasDuplicateStatusDates = false;
			var duplicateStatusDates = [];
			for (var i = 0; i < statusDropdowns.length; i++) {
			  for (var j = 0; j < statusDropdowns.length; j++) {
					var value1 = Utils.civicsDropdownValue($(statusDropdowns[i]));
					var value2 = Utils.civicsDropdownValue($(statusDropdowns[j]));
			    if (value1 == value2	&& i != j && value1) {
						duplicateStatusDates.push($(statusDropdowns[i]).attr('name'));
						validationErrors[$(statusDropdowns[i]).attr('name')] = i18n.t('CIVICS.COMMON.DUPLICATE_STATUS_DATE');
						validationErrors[$(statusDropdowns[j]).attr('name')] = i18n.t('CIVICS.COMMON.DUPLICATE_STATUS_DATE');
						hasError = true;
						hasDuplicateStatusDates = true;
			    }
			  }
			}

			if (hasError) {
				ViewManager.errorToWindow({validationError:validationErrors},self);

				if (hasDuplicateStatusDates && hasStatusDateOrderErrors) {
					for(var i = 0; i < duplicateStatusDates.length; i++) {
						var selector =  "[name='{0}']".format(duplicateStatusDates[i]);
						var dateFields = self.$el.find(selector).parents('.status-date-group').find('.civics-datepicker');
						_.forEach(dateFields, field=>{
							if($(field).val() == ''){
								var $parent = $(field).parents(".field");
								$(field).parents(".field").removeClass('error');
								$parent.find(".error-message").remove();
							}
						});
					}

					this.ui.filterContentMainList.find('.datepicker-range-container').each(function(){
						var from, to;
						$(this).find('input').each(function(){
							var i = $(this);
							var prop = i.attr('data-property');

							if(prop) {
								if(prop.indexOf("-from") > 0) {
									from = i;
								}

								if(prop.indexOf("-to") > 0){
									to = i;
								}
							}
						});

						if(!_.isEmpty(from) && !_.isEmpty(to)){
							if(Utils.dateTimeString(to.val()) >= Utils.dateTimeString(from.val())) {
								from.parents(".field").removeClass('error');
								from.parents(".field").find(".error-message").remove();
								to.parents(".field").removeClass('error');
								to.parents(".field").find(".error-message").remove();
							}
						}
					});
				}

				ViewManager.scrollToError({validationError:validationErrors},self);
				return;
			}

			if(andFilter.length>0 && orFilter.length == 0){
				retFilter.And = andFilter;
			} else if(andFilter.length == 0 && orFilter.length==1){
				retFilter = orFilter[0];
			} else {
					if ( !_.isEmpty(andFilter)) {
						if ( !retFilter.And ){
							retFilter.And = [];
						}
						retFilter.And.push.apply(retFilter.And,andFilter);
					}
					if ( !_.isEmpty(orFilter)) {
						if ( !retFilter.Or ){
							retFilter.Or = [];
						}
						retFilter.Or.push.apply(retFilter.Or,orFilter);
					}
			}
			this.totalCount(filterCount);
			if(filterCount > 0) {
				self.ui.totalCount.show();
				self.ui.btnClear.show();

				if(filterCount==1) {
					self.ui.totalCountLabel.text(i18n.t('CIVICS.COMMON.FILTER_APPLIED'));
				} else {
					self.ui.totalCountLabel.text(i18n.t('CIVICS.COMMON.FILTERS_APPLIED'));
				}

			}

			if ( __DEV__ ){
				console.log('retFilter ',retFilter,JSON.stringify(retFilter));
				console.log('rawData ',rawData);
				console.log('queryStrings ',queryStrings);
			}
			if ( !(disableNotifyParent === true)){
				if($('.filter-list-header:visible').length > 0 && !this.isInViewport($('.filter-list-header:visible')) && !isInitialLoad){
					$([document.documentElement, document.body]).animate({
						scrollTop: ($('.filter-list-header:visible').offset().top)
					}, 500);
				}
				// if the filter is not from the button, add a flag that it is from hashchange event
				if(!e)
					rawData.updateFromHashChange = true;

				this.channel.trigger('filter:updated', retFilter, rawData, queryStrings);
			}

			// If the filter is being called by a button
			if(e !== undefined) {
				this.updateHashFromModelParameter(rawData);
			}
			this.updateRangeSelectValues();
		},
		updateHashFromModelParameter: function(rawData, rememberedSavedFilter){
			let filterObj = this.channel.request('filter:getUrlParameters');
			let filterType = this.config.filterType;
			let hash;

			if (rememberedSavedFilter) {
				hash = `#${filterType}/${rememberedSavedFilter}`;
			} else {
				hash = "#" + this.config.filterType + "/" + extendedFilterUtility.minifyFilterString(JSON.stringify(filterObj)); 
			}
			
			window.location.hash = hash;
			this.hashFilteredUpdate = true;

			if (this.config.useSessionStorage) {
				if (this.config.saveDashboardTabData) {
					App.sessionStorage.set('CIVICS', 'FILTER_MYDASH_DATA', this.config.filterType); // this storage is only use to set the active tab on My Dashboard
				}
				App.sessionStorage.set('CIVICS', 'FILTER_' + this.config.filterType.toUpperCase() + '_DATA', hash);
			} else {
				return; 
			}
		},
		updateHashWithForm(resetPageToOne) {
			// Update the hash table of the filter on the page (does not reload the page)
			var hashReturn = "#" + this.config.filterType + "/" + this.buildQueryStringFromFilter(ViewManager.fromWindow(this));

			this.triggerMethod('criteria:getValue');
			this.triggerMethod('page:getValue');

			if(this.criteria != undefined) {
				if(hashReturn.charAt(hashReturn.length-1) == '&'){
					hashReturn += "viewCriteria=" + this.criteria;
				} else {
					hashReturn += "&viewCriteria=" + this.criteria;
				}
			}

			if(this.page > 1 && !resetPageToOne) {
				if(hashReturn.charAt(hashReturn.length-1) == '&'){
					hashReturn += "pageNumber=" + this.page;
				} else {
					hashReturn += "&pageNumber=" + this.page;
				}
			}

			if(this.sortField !== undefined && this.sortField.length > 0) {
				if(hashReturn.charAt(hashReturn.length-1) == '&'){
					hashReturn += "sortOrder=" + encodeURIComponent(this.sortField);
				} else {
					hashReturn += "&sortOrder=" + encodeURIComponent(this.sortField);
				}
			}

			if(this.config.useSessionStorage) {
				App.sessionStorage.set('CIVICS', 'FILTER_MYDASH_DATA', this.config.filterType);
				App.sessionStorage.set('CIVICS', 'FILTER_' + this.config.filterType.toUpperCase() + '_DATA', hashReturn);
			}

			window.location.hash = hashReturn;
			// create event that will alert the portlet code that the filter is doing the URL update
			this.hashFilteredUpdate = true;
		},
		// Recursively strip '%' wildcards from "Like" operator values only (search/text fields,
		// which applyFilter wraps as %value%). Exact-match (Equal) values and type codes keep any
		// literal '%' so their checkboxes still match and restore from the URL. HPS-137769
		stripLikeWildcards: function(filterGroup){
			if(!filterGroup) { return; }
			var walk = (arr)=>{
				if(!_.isArray(arr)) { return; }
				_.each(arr, (f)=>{
					if(f){
						if(f.operator === 'Like' && typeof f.value === 'string'){
							f.value = f.value.replace(/%/g, '');
						}
						if(f.And) { walk(f.And); }
						if(f.Or) { walk(f.Or); }
					}
				});
			};
			walk(filterGroup.And);
			walk(filterGroup.Or);
		},
		buildFormValueWithQueryString: function(filters){
			let formValue = [];

			if(filters){
				if(filters.dateCriteriaPicker){ //date picker criteria
					_.each(filters.dateCriteriaPicker, (dateCrit)=>{
						formValue.push({
							name: dateCrit.property,
							value: dateCrit.value
						});
					});
				}
				if(filters.taskOpenClosed){ 
					formValue.push({ name: 'Closed Tasks.closed', value: true});
					formValue.push({ name: 'Open Tasks.open', value: true });
				}
				if(filters.taskStatus){ 
					formValue.push({ name: 'Scheduled Tasks.scheduled', value: true});
					formValue.push({ name: 'Unscheduled Tasks.unscheduled', value: true });
				}
				if(filters.assignmentOpenClosed){ 
					formValue.push({ name: 'Closed Assignments.closed', value: true });
					formValue.push({ name: 'Open Assignments.open', value: true });
				}
				if(filters.assignmentStatus){ 
					formValue.push({ name: 'Scheduled.scheduled', value: true });
					formValue.push({ name: 'Not Scheduled.notScheduled', value: true });
				}
				if(filters.status){ 
					if(this.config.filterType == 'projects'){
						formValue.push({ name: 'Closed Projects.closed', value: true });
						formValue.push({ name: 'Open Projects.open', value: true });
					}else{
						formValue.push({ name: 'Closed Records.closed', value: true });
						formValue.push({ name: 'Open Records.open', value: true });
					}
				}

				if(filters.extendedFilter){
					if(filters.extendedFilter.And){
						_.each(filters.extendedFilter.And, (andFilter)=>{
							if(andFilter.property == 'instrumentSubTypeCode' || andFilter.property == 'portalDescription' || andFilter.property == 'instrumentMilestoneCode'){
								formValue.push({
									name: andFilter.property + '.' + this.camelize(andFilter.value),
									value: true
								});
							}
							else if(andFilter.property == 'IsClosedInstrument'){ // Open / Closed Projects checkbox
								let name = '';
								if(this.config.filterType == 'projects'){
									name = andFilter.value == 'true' ? 'Closed Projects.closed' : 'Open Projects.open';
								}else{
									name = andFilter.value == 'true' ? 'Closed Records.closed' : 'Open Records.open';
								}
								formValue.push({
									name:  name,
									value: true
								});
							}
							else if(andFilter.property == 'status'){ // Open / Closed Assignments checkbox
								let name = '';
								if(this.config.filterType == 'assignments'){
									name = andFilter.value == 'true' ? 'Closed Assignments.closed' : 'Open Assignments.open';
								}else{
									name = andFilter.operator == 'NotEqual' ? 'Closed Tasks.closed' : 'Open Tasks.open';
								}
								
								formValue.push({
									name:  name,
									value: true
								});
							}
							else if(andFilter.property == 'scheduledDateTime' && !andFilter.value){  // Scheduled / Not Scheduled checkbox
								let name = '';
								if(this.config.filterType == 'tasks'){
									name = andFilter.operator == 'IsNotNull' ? 'Scheduled Tasks.scheduled'  : 'Unscheduled Tasks.unscheduled';
								}else{
									name = andFilter.operator == 'NotEqual' ? 'Scheduled.scheduled'  : 'Not Scheduled.notScheduled';
								}
								formValue.push({
									name: name,
									value: true
								});
								// for dropdown view
								formValue.push({
									name:  'viewCriteria',
									value: andFilter.operator == 'IsNotNull' ? 'scheduled'  : 'notScheduled'
								});
							}
							else if(andFilter.property == 'hasopenviolation'){ // My Tasks Open Violation checkbox
								formValue.push({
									name: andFilter.operator == 'Equal' ? 'Open Violations.y'  : '',
									value: true
								});
							}
							else if(andFilter.isViewCriteria){
								formValue.push({
									name:  'viewCriteria',
									value: andFilter.criteriaValue
								});
							}
							else{
								let operatorVal = this.getOperatorValue(andFilter.operator);
								let fieldValue = andFilter.value;
								// operatorVal value only return for date range
								// getOperatorValue() return -to or -from based on the operator
								if(operatorVal != ''){
									let dateVal = new Date(andFilter.value);
									if(andFilter.operator == 'LessThan') //
										dateVal.setDate(dateVal.getDate() - 1); // we add 1 day for date filter 'to' during fetch so we need to remove that before setting that value on field

										fieldValue = Utils.dateStringFromDate(dateVal);
								}
								formValue.push({
									name: andFilter.property + operatorVal,
									value: fieldValue
								});
							}
						});
					}

					// Handle nested Or groups
					if(filters.extendedFilter.Or){
						_.each(filters.extendedFilter.Or, (orFilter)=>{
							if(orFilter.Or){
								_.each(orFilter.Or, (nestOrFilter)=>{
									if(nestOrFilter.property == 'instrumentSubTypeCode' || nestOrFilter.property == 'instrumentMilestoneCode'){
										formValue.push({
											name: nestOrFilter.property + '.' + this.camelize(nestOrFilter.value),
											value: true
										});
									}else{
										let val = JSV.isDate_(nestOrFilter.value) ? (new Date(nestOrFilter.value)).toLocaleDateString() : nestOrFilter.value;
										formValue.push({
											name: nestOrFilter.property,
											value: val
										});
									}
								});
							}
						});
					}

					// Handle flat Or filters 
					if(filters.extendedFilter.Or){
						_.each(filters.extendedFilter.Or, (orFilter)=>{
							if(orFilter.property == 'instrumentSubTypeCode' || orFilter.property == 'instrumentMilestoneCode'){
								formValue.push({
									name: orFilter.property + '.' + this.camelize(orFilter.value),
									value: true
								});
							}else{
								let val = JSV.isDate_(orFilter.value) ? (new Date(orFilter.value)).toLocaleDateString() : orFilter.value;
								formValue.push({
									name: orFilter.property,
									value: val
								});
							}
						});
					}

					if(filters.types){
						_.each(filters.types, (type)=>{
							formValue.push({
								// Must mirror customAttributesCheckboxName (camelize + strip '.') so the
								// generated name matches the checkbox's name attribute. Using the raw
								// type.Code left values with spaces/special chars (e.g. "A & B") unmatched,
								// so those type checkboxes were not checked when loaded from the URL. HPS-137769
								name: 'instrumentSubType' + '.' + this.camelize(type.Code).replace('.', ''),
								value: true,
								"data-extendedattributes": "[{instrumentTypeID:" + type.ID +"}]"
							});
						});
					}
				}

				if(filters.orderBy && filters.orderBy.length > 0){
					var prop = null;

					if(filters.orderBy[0].Property != null) {
						prop = filters.orderBy[0].Property;
					} else {
						prop = filters.orderBy[0].property;
					}

					if(prop !=null) {
						formValue.push({
							name: "sortOrder",
							value: prop
						});
					}

				}

				if(filters.page && filters.page.length > 0){
					formValue.push({
						name: "pageNumber",
						value: ((filters.page[0].Start - 1) / (filters.page[0].Max - 1)) + 1
					});
				}
			}
			return formValue;
		 },
		 getOperatorValue: function(operator){
			let val = '';
			if(operator){
				if(operator == 'GreaterThan' || operator == 'GreaterThanOrEqual'){
					val = '-from';
				}else if(operator == 'LessThan' || operator == 'LessThanOrEqual'){
					val = '-to';
				}
			}
			return val;
		 },
		 getViewCriteria: function(dateCriteria){
			var fromDate = new Date(dateCriteria);
			var toDate = new Date();

			var result = (toDate.getTime() - fromDate.getTime())/ (1000 * 60 * 60 * 24);
			return Math.trunc(result);
		 },
		isInViewport: function(obj) {
			var elementTop = $(obj).offset().top;
			var elementBottom = elementTop + $(obj).outerHeight();
			var viewportTop = $(window).scrollTop();
			var viewportBottom = viewportTop + $(window).height();
			return elementBottom > viewportTop && elementTop < viewportBottom;
		},
		totalCount:function(num){
			this.totalfilterCount = num;
			this.ui.totalCount.text(num);
		},
		clearSpecific:function(root, apply=true){

			var self = this;
			if ( !root ){
				root = this.$el;
			}

			//reset all filter groups' (filters-group) facet-count;
			root.find('input').each(function(){
				if($(this).attr('type')==='checkbox'){
					$(this).prop('checked', false);
				} else if($(this).hasClass('droppy-input')) {
					Utils.clearDroppy($(this));

					// if this is a status date dropdown, also update
					// the names/ids on the status date inputs
					if($(this).closest('.field').hasClass('date-criteria-picker')){
						self.updateStatusDates($(this),'');
					}
				} else {
					$(this).val('').change();
					if($(this).keyup){
						$(this).keyup();
					}
				}
			});

			// Clear count of checkboxes
			root.find('.quantity-badge').text(0);

			//un-select any options
			root.find('select, .droppy-input').each(function() {
				$(this).val('').change();
			});

			if( apply ){
				this.applyFilter();
			}
		},
		shareClicked:function() {
			if(navigator.share) {
				ViewManager.navigatorShare( i18n.t('CIVICS.COMMON.SEARCH'), window.location.href,
					function() {
						this.sendUrlLayoutView = new share_email_view({
							config: this.config,
							modalRegion: this.modalRegion,
							URLPath: window.location.href,
							translationPath: this.translationPath
						});
						this.modalRegion.show(this.sendUrlLayoutView);
						this.modalRegion.showModal();
					}.bind(this)
				);
			 } else {
				this.sendUrlLayoutView = new share_email_view({
					config: this.config,
					modalRegion: this.modalRegion,
					URLPath: window.location.href,
					translationPath: this.translationPath
				});

				this.modalRegion.show(this.sendUrlLayoutView);
				this.modalRegion.showModal();
			}
		},
		clearFilter:function(e){
			e.preventDefault();
			this.clearSpecific(null,false);
		},
		clearFilterSection:function(e) {
			e.preventDefault();
			this.clearSpecific($(e.target).closest('.filters-group'));
		},
		buildAddressFields: function(control) {
			var addressFields = AddressFilter.getLocaleSpecific(ViewManager.globalConfig().get('cultureInfo'));
			if (this.config.storedProcedureMode && control && control.additionalFields && AvailableFeatures.ExpandFilterCriteria()) {
				_.forEach(control.additionalFields, function(field){
					if(addressFields){
						let pos  = field.displayPosition && field.displayPosition < addressFields.length ? field.displayPosition : addressFields.length;
						addressFields.splice(pos, 0, field);
					}

				});
			}
			return addressFields;
		},
		buildAddressDropDownFields: function () {
			var self = this;
			var dropDownFields = _.where(that.addressFields, { dropDown: true });
			const codeDefPromises = dropDownFields.map((config) => {
					var oCodes = new CodeDefinitionCollection();
					oCodes.moniker = config.moniker;
				var codeDefPromise = new Promise((resolve) => {
					oCodes.fetch({
						error: function error(response) {
							reject(response);
						}, success: function success(model) {
							resolve(model.models);
						}
					});
				});
				return codeDefPromise.then(models => config.dropDownOptions = models);
			});

			Promise.all(codeDefPromises)
				.then(() => self.statusFetch.resolve())
				.catch((response) => {
							ViewManager.errorToWindow(response, this);
					});
		},
		buildFilterTag:function(properties){
			//console.log('Gotta add the code to build filter tags! Check out the original filter view for ideas, though I think there\'s a better way to do it.');
		},
		updateRangeSelectValues:function(){
			//console.log('Gotta add the code to update the selected value in a range to match the range\'s textboxes. Check out the original filter view for ideas. It works, though the building of the display text could be improved');
		},
		buildQueryStringFromFilter: function(params, preName = '') {
			var queryStringFromFilter = "";

			for (var name of Object.keys(params)) {
				if(typeof params[name] === 'object') {
					// if the current results is also an object, call recursively
					queryStringFromFilter += this.buildQueryStringFromFilter(params[name], preName + encodeURIComponent(name) + ".")
				} else {
					if(params[name] !== undefined && params[name] !== false && params[name] !== '') {
						// encode item and add it to the URL being built
						queryStringFromFilter += preName + encodeURIComponent(name) + '=' + encodeURIComponent(params[name]) + '&';
					}

				}
			}

			return queryStringFromFilter;
		},
		buildFilterFromQueryString: function(params) {
			var filtersFromQueryString = [];

			// Fill object in way that the toWindow function will work correctly
			for (var name of params.keys()) {
				filtersFromQueryString.push({name: name, value: params.get(name)});
			}

			return filtersFromQueryString;
		},
		newFilterGroup: function(group){
			var self = this;
			var oGroup = this.newGroup(group,'<li/>');

			// filter group has to have a class so facet, clear section will be able to find it
			oGroup.addClass('filters-group form-group');

			if ( group.showFilterSection ){
				//this will generate the "bar" on top of each filter group
				oGroup.addClass('filters-section');
			}

			var oCollapsibleDiv = this.newGroup({}).attr({class:'collapsible-content expanded'});
			_.forEach(group.controls, function(control){
				var inputGroup;// input group is for a wrapper that wraps only "one" control. Daterange is considered to be a control
				var child;
				// checkboxes with the 's' is intentional. That way we can futher group
				// the checkboxes into an "or" filter
				if ( control.type.toUpperCase() == "CHECKBOXES" ){
					child = self.buildCheckboxesInternal(control);
				}
				else if ( control.type.toUpperCase() == "TEXT" ){
					child = self.buildTextboxInternal(control);
				}
				else if ( control.type.toUpperCase() == "ADDRESSES" ){
					if ( !control.logic )control.logic='And';
					child = self.buildAddressesInternal(control);
				}
				else if ( control.type.toUpperCase() == "DATERANGE" ){
					//default logic to "And"
					if ( !control.logic )control.logic='And';
					child = self.buildDateRangeInternal(control);
					inputGroup = $('<div>');   // create a non input-group div so it wont be pulled for generating the filter twice
				}

				if(child){
					//default logic to 'Or' if it still hasn't been set
					if ( !control.logic )control.logic='Or';

					if ( !inputGroup ) {
						// wrap a child with an input-group with all the input properties
						inputGroup =  $('<div>').attr({
							class: 'input-group',
							'data-logic': control.logic,
							'data-excludeFromFilter': control.excludeFromFilter,
							'data-filterGroupType': control.filterGroupType,
							'data-groupHeader':control.groupHeader
						});
					}
					// now setup the property name for the input group
					var bindProp = control.propertyName;

					inputGroup.attr({	'data-property': bindProp});
					inputGroup.append(child);

					if (group.canCollapse){
						oCollapsibleDiv.append(inputGroup);
					}
					else {
						oGroup.append(inputGroup);
					}
				}
			});

			if ( group.canCollapse ){
				oGroup.append(oCollapsibleDiv);
			}

			// show clear button for the curr section
			//<a href="#" role="button" class="clear-filter active">Clear</a>
			if ( group.showClearSection ){
				var btnClear = $('<a>').text(i18n.t('CIVICS.COMMON.CLEAR')).attr({
					role:'button',
					class:'clear-filter link-secondary active'
				});
				btnClear.click(function(e){
					//clear everything in the same group only
					self.clearSpecific(btnClear.closest('.filters-group'));
				});

				if ( group.canCollapse ){
					oCollapsibleDiv.append(btnClear);
				}
				else {
					oGroup.append(btnClear);
				}
			}
			return oGroup;
		},
		endCustom: function(text) {
			// providing custom end text for elements using an array passed in of descriptive text elements
			let returnText = "";

			if (Array.isArray(text)) {
				while(text.length > 0) {
			    let temp = text.pop();

					if (temp != undefined) {
						returnText += temp.replace(/[^A-Z0-9]/ig, "_");
					}
				}
			}

			return returnText;
		},
		camelize:function(str) {
			if(str == undefined) {
				return "";
			} else {
				return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(letter, index) {
					return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
				}).replace(/\s+/g, '');
			}
		},
		escapeAttribute: function(attr){
			return String(attr).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
		},
		templateHelpers:function(){
			// if (__DEV__) console.log('itv_filter -- templateHelpers');
			var self = this;
			const hash = window.location.hash.toLowerCase();
			const isTask = this.filterName.toLowerCase() === 'mytaskcard';
			const isProjectWithFilters = this.filterName.toLowerCase() === 'myprojectscard' && this.config.saveDashboardFiltersEnabled;

			return {
				showSavedFiltersRegion: isTask || isProjectWithFilters,
				saveDashboardFiltersEnabled: this.config.saveDashboardFiltersEnabled,
				allowSharing: this.config.allowSharing,
				filterName: this.filterName,
				filterDivName: "filterDiv"+ this.filterName,
				toggleName: function(name){
					return i18n.t('CIVICS.COMMON.TOGGLE_FILTER',{name:name});
				},
				expandedOrCollapsed:  this.config.expanded ? 'expanded' : 'collapsed',
				groups: this.config.filterGroups,
				addressfields: self.addressFields,
				searchLabel: function(name){
					return i18n.t('CIVICS.COMMON.SEARCH') + ' ' + name;
				},
				clearLabel: function(name, controls = []){
					var controlNames = [];
					_.forEach(controls,control=>{

						if (control.displayName){
							controlNames.push(control.displayName);
						}
					});

					return i18n.t('CIVICS.COMMON.CLEAR')+' '+'<span class="scr">'+(name ? name : controlNames.join(', '))+'</span>';
				},
				propertyId: function(id = "missing", options) {
					options = (typeof options === 'string' || options instanceof String) ? options : '';
					return self.camelize(id) + options + self.endCustom([this.displayName, this.value]);
				},
				propertyIdAddress: function(id = "missing", options) {
					options = (typeof options === 'string' || options instanceof String) ? options : '';
					return "address." + self.camelize(id) + options + self.endCustom([this.displayName]);
				},
				logicCheck: function(logic) {
					return (logic ? logic : "Or");
				},
				customAttributesName: function(control, tofrom) {
					return self.escapeAttribute((control.propertyName != undefined ? control.propertyName : control.displayName) + (typeof tofrom == "string" ? tofrom : "").replace('.', ''));
				},
				customAttributesCheckboxName: function(control) {
					// NOTE: do NOT escapeAttribute here. This value is rendered via an escaped
					// mustache (name="{{name}}") in uiCivicsCheckbox.hbs, which already HTML-escapes it.
					// Escaping here too produced double-escaping (e.g. "&" -> "&amp;amp;"), so the live
					// DOM name no longer matched the hash-derived name built in buildFormValueWithQueryString,
					// leaving special-character checkboxes (e.g. "A & B") unchecked when loaded from the URL. HPS-137769
					return (control.propertyName != undefined ? control.propertyName : control.displayName).replace('.', '') + "." + self.camelize(control.value).replace('.', '');
				},
				customAttributes: function (control, filter = "text", input = "text", special = "text", tofrom = "", exclude) {
					var excludeFilter = exclude || (control.excludeFromFilter != undefined || special == "range" ? "data-excludeFromFilter = \"" + (control.excludeFromFilter ? true : false) + "\"" : "");
					if (exclude != undefined) {
						excludeFilter =  "data-excludeFromFilter = \"" + (exclude == true) + "\"";
					}

					var customData =
						excludeFilter +
						" data-property = \"" + self.escapeAttribute((control.propertyName != undefined ? control.propertyName : control.displayName) + (typeof tofrom == "string" ? tofrom : "")) + "\"" +
						" data-filterType = \"" + self.escapeAttribute((control.filterType != undefined ? control.filterType : filter)) + "\"" +
						" data-inputType = \"" + self.escapeAttribute(input) + "\"" +
						" data-displayName = \"" + self.escapeAttribute((control.displayName != undefined ? control.displayName : "")) + "\"" +
						" data-specialType = \"" + self.escapeAttribute(special) + "\"" +
						(control.queryStringId != undefined ? " data-queryStringId = \"" + self.escapeAttribute(control.queryStringId) + "\"" : "") +
						(control.alternateValues != undefined ? " data-alternateValues = \"" + self.escapeAttribute(checkbox.alternateValues.join('|')) + "\"" : "") +
						(control.relatedValues != undefined && control.relatedValues.length > 0 ? " data-relatedValues = \"" + self.escapeAttribute(control.relatedValues.join('|')) + "\"" : "") +
						((control.queryStringPureBind != undefined || input == "text" || special == "range") ? " data-queryStringPureBind = \"" + self.escapeAttribute((control.queryStringPureBind ? true : false)) + "\"" : "") +
						" data-extendedAttributes = \"" + self.escapeAttribute(JSV.stringify(control.extendedAttributes)) + "\"";

					return customData;
				},
				customAttributesAddress: function (control, input = "text") {
					var dataProperty = control.bind;
					if(_.isEmpty(dataProperty)){
						dataProperty = control.propertyName;
						if(_.isEmpty(dataProperty)){
							dataProperty = control.displayName;
						}
					}
					if(!_.isEmpty(self.addressPrefix)){
						dataProperty = self.addressPrefix+'.'+dataProperty;
					}
					var customData =
						"data-property = \"" + self.camelize(dataProperty) + "\"" +
						" data-excludeFromFilter = \"" + (control.excludeFromFilter ? true : false) + "\"" +
						" data-filterType = \"" + (control.filterType != undefined ? control.filterType : "address") + "\"" +
						" data-inputType = \"" + input + "\"" +
						" data-displayName = \"" + (control.displayName != undefined ? control.displayName : "") + "\"" +
						" data-specialType = \"address\"" +
						(control.queryStringId != undefined ? " data-queryStringId = \"" + control.queryStringId + "\"" : "") +
						((control.queryStringPureBind != undefined) ? " data-queryStringPureBind = \"" + (control.queryStringPureBind ? true : false) + "\"" : "") +
						" data-extendedAttributes = \"" + JSV.stringify(control.extendedAttributes) + "\"";

					return customData;
				},
				customAddressName: function (control, input = "text") {
					var dataProperty = control.bind;
					if(_.isEmpty(dataProperty)){
						dataProperty = control.propertyName;
						if(_.isEmpty(dataProperty)){
							dataProperty = control.displayName;
						}
					}
					if(!_.isEmpty(self.addressPrefix)){
						dataProperty = self.addressPrefix+'.'+dataProperty;
					}

					return self.camelize(dataProperty);
				},
			}
		}
	});
});
